export const kurumlarArr = [
  {
    img: "/assets/katilimcilar/2.png",
    name: "ADEKA İLAÇ SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/3.png",
    name: "AFACAN PLASTİK END. TEM ve SAĞLIK ÜRÜN. İNŞ. SAN. TİC. LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/4.png",
    name: "AKDAĞ SU"
  },
  {
    img: "/assets/katilimcilar/5.png",
    name: "AKSULAR GIDA LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/6.png",
    name: "ALTAŞ ŞİRKETLER GRUBU"
  },
  {
    img: "/assets/katilimcilar/7.png",
    name: "AMERICAN LIFE"
  },
  {
    img: "/assets/katilimcilar/8.png",
    name: "ARMOR ISI TRANSFER SAN. ve TİC.A.Ş."
  },
  {
    img: "/assets/katilimcilar/9.png",
    name: "ASÇELİK DÖKÜM İŞLEME SAN. ve TİC.A.Ş."
  },
  {
    img: "/assets/katilimcilar/10.png",
    name: "ASELSAN"
  },
  {
    img: "/assets/katilimcilar/11.png",
    name: "ASKON - ANADOLU ASLANLARI İŞ ADAMLARI DERNEĞİ"
  },
  {
    img: "/assets/katilimcilar/12.png",
    name: "ATAKUM BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/13.png",
    name: "ATASAM HASTANELERİ"
  },
  {
    img: "/assets/katilimcilar/14.png",
    name: "AYSAM ORTOPEDİ VE TIBBİ ALETLER SAN. TİC. LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/15.png",
    name: "BAFRA BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/16.png",
    name: "BAFRA TSO"
  },
  {
    img: "/assets/katilimcilar/17.png",
    name: "BAHADIR TIBBİ ALET CİHAZ VE İNŞAAT MAKİNA SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/18.png",
    name: "BİLGİ EĞİTİM KURUMLARI"
  },
  {
    img: "/assets/katilimcilar/19.png",
    name: "BORSAN KABLO ELEKTRİK AYDINLATMA İNŞAAT SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/20.png",
    name: "BOTAŞ - BORU HATLARI İLE PETROL TAŞIMA A.Ş."
  },
  {
    img: "/assets/katilimcilar/21.png",
    name: "CANİK BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/22.png",
    name: "CUMHURBAŞKANLIĞI İLETİŞİM BAŞKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/23.png",
    name: "CUMHURBAŞKANLIĞI İNSAN KAYNAKLARI OFİSİ"
  },
  {
    img: "/assets/katilimcilar/24.png",
    name: "CUMHURİYET BAŞSAVCILIĞI"
  },
  {
    img: "/assets/katilimcilar/25.png",
    name: "ÇAMSAN"
  },
  {
    img: "/assets/katilimcilar/26.png",
    name: "ÇALIŞMA VE SOSYAL GÜVENLİK BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/27.png",
    name: "ÇANKIRI TEKNOPARK"
  },
  {
    img: "/assets/katilimcilar/28.png",
    name: "ÇARŞAMBA BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/carsamba-tic-borsasi.png",
    name: "Çarşamba Ticaret Borsası"
  },
  {
    img: "/assets/katilimcilar/29.png",
    name: "ÇARŞAMBA TSO"
  },
  {
    img: "/assets/katilimcilar/30.png",
    name: "ÇİBA CAM İMALAT İTH.İHR.SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/31.png",
    name: "ÇORUM TEKNOPARK"
  },
  {
    img: "/assets/katilimcilar/32.png",
    name: "ÇORUM TSO"
  },
  {
    img: "/assets/katilimcilar/33.png",
    name: "D.L.P. DÜELSAN DÜNDAR ELEKTROMEKANİK SAN.TİC.LTD.ŞTİ."
  },
  {
    img: "/assets/katilimcilar/34.png",
    name: "DAMSAN MADENCİLİK DEMİR ÇELİK SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/35.png",
    name: "DATASSİST"
  },
  {
    img: "/assets/katilimcilar/36.png",
    name: "DELTAV UZAY TEKNOLOJİLERİ A.Ş."
  },
  {
    img: "/assets/katilimcilar/37.png",
    name: "DEMİR İNŞAATMİMARLIK SAN.TİC.LTD.ŞTİ"
  },
  {
    img: "/assets/katilimcilar/38.png",
    name: "DOĞUŞ OKUL YAYINLARI TİC.LTD.ŞTİ"
  },
  {
    img: "/assets/katilimcilar/39.png",
    name: "DOKAP - DOĞU KARADENİZ PROJESİ BÖLGE KALKINMA İDARESİ BAŞKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/40.png",
    name: "DUDUOĞLU ÇELİK DÖKÜM SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/41.png",
    name: "DÜNYA MÜHENDİSLİK BİLGİSAYAR SİSTEMLERİ VE İLETİŞİM SAN.TİC.LTD.ŞTİ"
  },
  {
    img: "/assets/katilimcilar/42.png",
    name: "DÜNYAGÖZ HASTANELER GRUBU"
  },
  {
    img: "/assets/katilimcilar/43.png",
    name: "ELEKTRİK ÜRETİM A.Ş"
  },
  {
    img: "/assets/katilimcilar/44.png",
    name: "ENERJİ TABİ KAYNAKLAR BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/45.png",
    name: "ENGLISH TIME"
  },
  {
    img: "/assets/katilimcilar/46.png",
    name: "ERÇAL FINDIK OTOMOTİV SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/47.png",
    name: "ETİ BAKIR ANONİM ŞİRKETİ"
  },
  {
    img: "/assets/katilimcilar/48.png",
    name: "FBM ESTETİK TIP MERKEZİ"
  },
  {
    img: "/assets/katilimcilar/49.png",
    name: "FİNAL OKULLARI"
  },
  {
    img: "/assets/katilimcilar/50.png",
    name: "FKK GÜNEY OTO LASTİK TAKOZ SAN.TİC.LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/51.png",
    name: "GALTEK MÜHENDİSLİK ELEKTRİK İNŞAAT MAKİNA SAN.TİC.LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/52.png",
    name: "GREEN SANAT SPOR TURİZM SAN.TİC.LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/53.png",
    name: "GÜRSOY TARIMSAL ÜRÜNLER GIDA SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/54.png",
    name: "HAMPTON BY HILTON SAMSUN"
  },
  {
    img: "/assets/katilimcilar/55.png",
    name: "HAVELSAN"
  },
  {
    img: "/assets/katilimcilar/56.png",
    name: "HAVZA BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/57.png",
    name: "HAVZA TSO"
  },
  {
    img: "/assets/katilimcilar/58.png",
    name: "HAZİNE VE MALİYE BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/59.png",
    name: "İLKADIM BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/60.png",
    name: "İŞKUR"
  },
  {
    img: "/assets/katilimcilar/61.png",
    name: "KAMU DENETÇİLİĞİ KURUMU"
  },
  {
    img: "/assets/katilimcilar/62.png",
    name: "KAMU İHALE KURUMU"
  },
  {
    img: "/assets/katilimcilar/63.png",
    name: "KARİYER.NET"
  },
  {
    img: "/assets/katilimcilar/64.png",
    name: "KASTAMONU ENTEGRE AĞAÇ SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/65.png",
    name: "KASTAMONU TEKNOPARK"
  },
  {
    img: "/assets/katilimcilar/66.png",
    name: "KAZANCI HOLDİNG A.Ş."
  },
  {
    img: "/assets/katilimcilar/67.png",
    name: "KEFELİ OFSET MATBAACILIK OLUKLU MUKAVVA KUTU VE AMBALAJSAN.TİC.İTH.İHR.LTD.ŞTİ"
  },
  {
    img: "/assets/katilimcilar/68.png",
    name: "KENEVİRO TARIM ÜRETİM SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/69.png",
    name: "KIZILAY"
  },
  {
    img: "/assets/katilimcilar/70.png",
    name: "KOSGEB"
  },
  {
    img: "/assets/katilimcilar/71.png",
    name: "KÖKTAŞ GRUP"
  },
  {
    img: "/assets/katilimcilar/72.png",
    name: "LESAFFRE TURQUIE MAYACILIK ÜRETIM SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/73.png",
    name: "LÖSEV"
  },
  {
    img: "/assets/katilimcilar/74.png",
    name: "LUNART SAĞLIK ÜRÜNLERİ TİC. LTD.ŞTİ"
  },
  {
    img: "/assets/katilimcilar/75.png",
    name: "MAHYA DİŞ DEPOSU"
  },
  {
    img: "/assets/katilimcilar/76.png",
    name: "MAKİNA VE ENERJİ ENDÜSTRİYEL ÇÖZÜMLER GIDA TURİZM SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/77.png",
    name: "MARS SANAYİ ÜRN. AMBALAJ İTH. İHR. SAN. TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/78.png",
    name: "MATLI HOLDİNG – MATLI ŞİRKETLER GRUBU"
  },
  {
    img: "/assets/katilimcilar/79.png",
    name: "MC FİLTRE SAN. ve TİC. LTD .ŞTİ."
  },
  {
    img: "/assets/katilimcilar/80.png",
    name: "MEDİCAL PARK HASTANELER GRUBU"
  },
  {
    img: "/assets/katilimcilar/81.png",
    name: "MEDİCANA SAMSUN ÖZEL SAĞLIK HİZ. A.Ş."
  },
  {
    img: "/assets/katilimcilar/82.png",
    name: "MİLLİ SAVUNMA BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/83.png",
    name: "MÜSİAD"
  },
  {
    img: "/assets/katilimcilar/84.png",
    name: "NÜKLEER DÜZENLEME KURUMU"
  },
  {
    img: "/assets/katilimcilar/1.png",
    name: "19 MAYIS BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/85.png",
    name: "ORTA KARADENİZ KALKINMA AJANSI"
  },
  {
    img: "/assets/katilimcilar/86.png",
    name: "OTAT GIDA SAN. ve TİC.LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/87.png",
    name: "OTOKOÇ OTOMOTİV"
  },
  {
    img: "/assets/katilimcilar/88.png",
    name: "ÖZEL DİNAMİK OKULLARI"
  },
  {
    img: "/assets/katilimcilar/89.png",
    name: "ÖZEL GÖKTÜRK HAVACILIK LİSESİ"
  },
  {
    img: "/assets/katilimcilar/90.png",
    name: "ÖZERTEKNİK İKLİMLENDİRME VE ENERJİ A.Ş."
  },
  {
    img: "/assets/katilimcilar/91.png",
    name: "ÖZYILMAZ FINDIK TİC. ve SAN. LTD. ŞTİ"
  },
  {
    img: "/assets/katilimcilar/92.png",
    name: "PARK INN BY RADISSON SAMSUN"
  },
  {
    img: "/assets/katilimcilar/93.png",
    name: "PERA ÖZEL EĞİTİM KURUMLARI"
  },
  {
    img: "/assets/katilimcilar/94.png",
    name: "POLFİSAN KENT MOBİLYALARI İNŞAAT SAN. ve TİC.LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/95.png",
    name: "RED BULL"
  },
  {
    img: "/assets/katilimcilar/96.png",
    name: "REKABET KURUMU"
  },
  {
    img: "/assets/katilimcilar/97.png",
    name: "RESMAN CAM PVC ALÜMİNYUM SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/98.png",
    name: "RHEINLAND PRIVATSCHULE DİL EGİTİM"
  },
  {
    img: "/assets/katilimcilar/99.png",
    name: "ROKETSAN A.Ş."
  },
  {
    img: "/assets/katilimcilar/100.png",
    name: "SAĞLIK BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/101.png",
    name: "SAHİL GÜVENLİK"
  },
  {
    img: "/assets/katilimcilar/102.png",
    name: "SAMGAZ DOĞAL GAZ DAĞITIM A.Ş."
  },
  {
    img: "/assets/katilimcilar/103.png",
    name: "SAMKEP İLETİŞİM TEKNOLOJİ HİZMETLERİ LTD.ŞTİ."
  },
  {
    img: "/assets/katilimcilar/104.png",
    name: "SAMPA OTOMOTİV SAN. ve TİC. A.Ş"
  },
  {
    img: "/assets/katilimcilar/105.png",
    name: "SAMSUN BÜYÜKŞEHİR BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/106.png",
    name: "SAMSUN ÇARŞI BÜYÜKMAĞAZACILIK VE KUYUMCULUK A. Ş."
  },
  {
    img: "/assets/katilimcilar/107.png",
    name: "SAMSUN GENÇLİK VE SPOR İL MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/108.png",
    name: "SAMSUN İL AFET VE ACİL DURUM MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/109.png",
    name: "SAMSUN İL EMNİYET MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/110.png",
    name: "SAMSUN İL JANDARMA KOMUTANLIĞI"
  },
  {
    img: "/assets/katilimcilar/111.png",
    name: "SAMSUN İL KÜLTÜR VE TURİZM MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/112.png",
    name: "SAMSUN İL MİLLİ EĞİTİM MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/113.png",
    name: "SAMSUN MÜFTÜLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/114.png",
    name: "SAMSUN SEGMAN ve GÖMLEK SAN.TİC.LTD. ŞTİ."
  },
  {
    img: "/assets/katilimcilar/115.png",
    name: "SAMSUN TEKNİK HAVA ARACI BAKIM VE ONARIM MERKEZİ"
  },
  {
    img: "/assets/katilimcilar/116.png",
    name: "SAMSUN TEKNOPARK A.Ş."
  },
  {
    img: "/assets/katilimcilar/117.png",
    name: "SAMSUN ÜNİVERSİTESİ UÇUŞ AKADEMİSİ"
  },
  {
    img: "/assets/katilimcilar/118.png",
    name: "SAMSUN ÜNİVERSİTESİ TEKNOLOJİ TRANSFER OFİSİ"
  },
  {
    img: "/assets/katilimcilar/119.png",
    name: "SAMSUN VALİLİĞİ"
  },
  {
    img: "/assets/katilimcilar/120.png",
    name: "SAMSUN VERGİ DAİRESİ BAŞKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/121.png",
    name: "SAMSUN YURT SAVUNMA SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/122.png",
    name: "SAMSUNSPOR"
  },
  {
    img: "/assets/katilimcilar/123.png",
    name: "SAVUNMA SANAYİ BAŞKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/124.png",
    name: "SARPLAST PLASTİK SAN. ve TİC. LTD ŞTİ."
  },
  {
    img: "/assets/katilimcilar/125.png",
    name: "SERMAYE PİYASASI KURULU"
  },
  {
    img: "/assets/katilimcilar/126.png",
    name: "SERMAYE PİYASASI LİSANSLAMA SİCİL VE EĞİTİM KURULUŞU A.Ş"
  },
  {
    img: "/assets/katilimcilar/127.png",
    name: "SGK"
  },
  {
    img: "/assets/katilimcilar/128.png",
    name: "SİMDER- SAMSUN İNŞAATÇILAR VE MÜTEAHHİTLER DERNEĞİ"
  },
  {
    img: "/assets/katilimcilar/128_1.png",
    name: "SİMOGG-SAMSUN MÜTEAHHİTLERİ ORTAK GİRİŞİM GRUBU İNŞAAT SANAYİ TİCARET ANONİM ŞTİ."
  },
  {
    img: "/assets/katilimcilar/129.png",
    name: "TAÇ MAKİNA SAN. ve TİC. LTD ŞTİ."
  },
  {
    img: "/assets/katilimcilar/130.png",
    name: "TED-TÜRK EĞİTİM DERNEĞİ"
  },
  {
    img: "/assets/katilimcilar/131.png",
    name: "TEKKEKÖY BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/teknokent-koleji.png",
    name: "Teknokent Koleji"
  },
  {
    img: "/assets/katilimcilar/132.png",
    name: "TELLİOĞLU METAL SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/133.png",
    name: "TERME BELEDİYESİ"
  },
  {
    img: "/assets/katilimcilar/134.png",
    name: "TEOL DİL OKULLARI"
  },
  {
    img: "/assets/katilimcilar/135.png",
    name: "TİCARET BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/136.png",
    name: "TOKAT TEKNOPARK"
  },
  {
    img: "/assets/katilimcilar/137.png",
    name: "TOPALOĞLU BALIKÇILIK"
  },
  {
    img: "/assets/katilimcilar/138.png",
    name: "TUSAŞ - TÜRK HAVACILIK VE UZAY SANAYİİ A.Ş."
  },
  {
    img: "/assets/katilimcilar/139.png",
    name: "TÜRKİYE İSTATİSTİK KURUMU SAMSUN BÖLGE MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/140.png",
    name: "TÜRKİYE KÖMÜR İŞLETMELERİ KURUMU GENEL MÜDÜRLÜĞÜ"
  },
  {
    img: "/assets/katilimcilar/141.png",
    name: "TÜRK TELEKOM A.Ş."
  },
  {
    img: "/assets/katilimcilar/142.png",
    name: "TÜRKŞEKER - TÜRKİYE ŞEKER FABRİKALARI A.Ş"
  },
  {
    img: "/assets/katilimcilar/143.png",
    name: "TYH TEKSTİL A.Ş."
  },
  {
    img: "/assets/katilimcilar/144.png",
    name: "UG DEMİR ÇELİK SAN. ve TİC. LTD ŞTİ."
  },
  {
    img: "/assets/katilimcilar/145.png",
    name: "UĞUR OKULLARI"
  },
  {
    img: "/assets/katilimcilar/146.png",
    name: "ULAŞTIRMA VE ALTYAPI BAKANLIĞI"
  },
  {
    img: "/assets/katilimcilar/147.png",
    name: "ULUSOY UN A.Ş."
  },
  {
    img: "/assets/katilimcilar/148.png",
    name: "UNSAN UN SAN. ve TİC. A.Ş."
  },
  {
    img: "/assets/katilimcilar/149.png",
    name: "UZAI TEKNOLOJI"
  },
  {
    img: "/assets/katilimcilar/150.png",
    name: "VAKIF KATILIM A.Ş."
  },
  {
    img: "/assets/katilimcilar/151.png",
    name: "VAKIFBANK A.Ş."
  },
  {
    img: "/assets/katilimcilar/152.png",
    name: "YAĞMAKSAN A.Ş."
  },
  {
    img: "/assets/katilimcilar/153.png",
    name: "YAŞAR GRUP"
  },
  {
    img: "/assets/katilimcilar/154.png",
    name: "YEDAŞ - YEŞİLIRMAK ELEKTRİK DAĞITIM A.Ş."
  },
  {
    img: "/assets/katilimcilar/155.png",
    name: "YENİBİRİŞ DİJİTAL İNSAN KAYNAKLARI VE TEKNOLOJİ A.Ş."
  },
  {
    img: "/assets/katilimcilar/156.png",
    name: "YEŞİLAY"
  },
  {
    img: "/assets/katilimcilar/157.png",
    name: "YEŞİLYURT DEMİR ÇELİK ENDÜSTRİ VE LİMAN İŞLETMELERİ A.Ş."
  },
  {
    img: "/assets/katilimcilar/158.png",
    name: "YILDIRIM HOLDİNG"
  },
  {
    img: "/assets/katilimcilar/159.png",
    name: "YÖN PAZARLAMA A.Ş."
  },
  {
    img: "/assets/katilimcilar/160.png",
    name: "YURTDIŞI TÜRKLER VE AKRABA TOPLULUKLAR BAŞKANLIĞI"
  }
];